import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { COLLECTIONS, PACKAGING_IMAGE } from "@/data/products";
import { useMedia } from "@/context/MediaContext";

const TILES = [
  { key: "for-her", to: "/collections/for-her", label: "For Her" },
  { key: "for-him", to: "/collections/for-him", label: "For Him" },
  { key: "unisex", to: "/collections/unisex", label: "Unisex" },
  { key: "discovery", to: "/collections", label: "10 ml Roll-Ons", slot: "packaging", fallback: PACKAGING_IMAGE },
];

export default function ShopByCategory() {
  const img = useMedia();
  return (
    <section data-testid="shop-by-category-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
      <Reveal className="max-w-xl mb-12">
        <p className="overline-label">Shop by category</p>
        <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">Express your character.</h2>
        <p className="mt-4 text-sm md:text-base text-black/55 leading-relaxed">Choose the emblematic pieces of the Reserve 30 fragrance wardrobe.</p>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {TILES.map((t, i) => {
          const c = COLLECTIONS[t.key];
          const src = c ? img(`collection_${t.key.replace("-", "_")}`, c.image) : img(t.slot, t.fallback);
          return (
            <Reveal key={t.key} delay={i * 0.08}>
              <Link to={t.to} data-testid={`category-tile-${t.key}`} className="group block">
                <div className="aspect-square overflow-hidden bg-[#EFE9E1]">
                  <img src={src} alt={t.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
                </div>
                <p className="mt-4 font-serif-brand text-xl md:text-2xl font-light link-line inline-block">{t.label}</p>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
